/** Formátování čísel a měsíců pro přehled (cs-CZ). Částky jsou v haléřích. */

const compact = new Intl.NumberFormat('cs-CZ', { notation: 'compact', maximumFractionDigits: 1 })
const shortMonth = new Intl.DateTimeFormat('cs-CZ', { month: 'short' })
const longMonth = new Intl.DateTimeFormat('cs-CZ', { month: 'long', year: 'numeric' })

/** Popisek osy Y: "150 tis.", "1,5 mil." (vstup v haléřích). */
export const formatAxisAmount = (minor: number) => (minor === 0 ? '0' : compact.format(minor / 100))

/** "říj" */
export const formatMonthShort = (date: Date) => shortMonth.format(date)

/** "Říjen 2026" */
export const formatMonthLong = (date: Date) => {
  const s = longMonth.format(date)
  return s.charAt(0).toUpperCase() + s.slice(1)
}

/** Procentní změna, "+12 %" / "-4 %". */
export const formatPercentChange = (current: number, previous: number) => {
  if (!previous) return null
  const pct = Math.round(((current - previous) / Math.abs(previous)) * 100)
  return `${pct > 0 ? '+' : pct < 0 ? '-' : ''}${Math.abs(pct)} %`
}
